<template>
  <div class="luckyValue" v-if="luckyValue != null && luckyValue.num != null">
    <div class="luckyValue_left">
      <div class="luckyValue_tit_1">当前幸运值：</div>
      <div class="luckyValue_tit_2">{{ luckyValue.num }}</div>
      <div class="luckyValue_tit_1 luckyValue_tit_3">幸运值满100，即可</div>
      <div class="luckyValue_tit_1 luckyValue_tit_4">兑换</div>
      <button class="button luckyValue_btn" @click="exchangeImage(true)">
        奖品
      </button>
    </div>
    <div class="luckyValue_right">
      <img
        class="luckyValue_right_image_center"
        src="../../assets/lottery/xingxing.png"
      />
      <div
        class="luckyValue_right_image_value_not"
        v-bind:style="{ height: luckyValueHeight + 'px' }"
      ></div>
      <img
        class="luckyValue_right_image_value"
        src="../../assets/lottery/integral_img.png"
      />
      <button
        class="button luckyValue_right_image_title"
        @click="exchangeLuckyValue(true)"
      >
        {{ luckyValueText }}
      </button>
    </div>
    <lottery-image-toast
      :toastShow="toastImageShow"
      v-on:isshowaction="exchangeImage(false)"
    />
    <redeem-prizes-toast
      :toastShow="redeemPrizesShow"
      v-on:isshowaction="exchangeLuckyValue(false)"
      @reloadData="reloadData"
    />
    <!-- <value-animation class="value-animation" /> -->
  </div>
</template>

<script lang="ts">
import { Vue, Options } from "vue-class-component";
import { Http, ResponseData } from "../../net/Http";
import { Urls } from "../../net/Urls";
import { LuckyValueModel } from "../../model/lottery/LotteryModel";
import LotteryImageToast from "../lottery/LotteryImageToast.vue";
import ValueAnimation from "../../components/lottery/ValueAnimation.vue";
import RedeemPrizesToast from "../../components/lottery/RedeemPrizesToast.vue";
import { openToast } from "toast-ts";
@Options({
  components: {
    LotteryImageToast,
    ValueAnimation,
    RedeemPrizesToast
  }
})
export default class LuckyValue extends Vue {
  private luckyValue: LuckyValueModel | null = null;
  private toastImageShow = false;
  private redeemPrizesShow = false;
  private luckyValueText = "";
  private luckyValueHeight = 55; // 55 ~ 0
  mounted() {
    this.getLuckyValue();
  }
  //TODO:添加字段满100 是否兑换了商品
  getLuckyValue() {
    Http.post<LuckyValueModel>(Urls.lottery_getLuckyValue, null).then(
      (res: LuckyValueModel) => {
        this.luckyValue = res;
        this.setValueData();
      },
      (err: ResponseData) => {
        console.log("LuckyValue", err.message);
        openToast(err.message);
      }
    );
  }
  setValueData() {
    if (this.luckyValue == null) return;
    if (this.luckyValue.num >= 100) {
      this.luckyValueHeight = 0;
    } else {
      this.luckyValueHeight = 55 - this.luckyValue.num * 0.55;
    }
    if (this.luckyValue != null && this.luckyValue.num >= 100) {
      this.luckyValueText = "兑换";
    } else {
      this.luckyValueText = "幸运值";
    }
  }
  exchangeImage(value: boolean) {
    this.toastImageShow = value;
  }
  exchangeLuckyValue(value: boolean) {
    console.log(value);
    if (this.luckyValueText == "兑换") {
      this.redeemPrizesShow = true;
    } else {
      this.redeemPrizesShow = false;
    }
  }
  reloadData() {
    this.redeemPrizesShow = false;
    this.getLuckyValue();
  }
}
</script>

<style scoped lang="less">
@import "../../style/BaseStyle.less";
.luckyValue {
  height: 140px;
  background-color: #f64746;
  border-radius: 10px;
  margin: 20px 20px;
  overflow: hidden;

  .luckyValue_left {
    width: 50%;
    float: left;
    text-align: left;
    margin: 0 0 0 0;
    padding: 0 0 0 0;
    .luckyValue_tit_1 {
      font-size: 12px;
      font-weight: 400;
      color: white;
      margin-top: 20px;
      margin-left: 16px;
    }
    .luckyValue_tit_2 {
      font-size: 22px;
      font-weight: bold;
      color: white;
      margin: 5px auto;
      margin-left: 16px;
    }
    .luckyValue_tit_3 {
      margin-top: 8px;
    }
    .luckyValue_tit_4 {
      float: left;
      margin-top: 5px;
    }
    .luckyValue_btn {
      margin-left: 10px;
      font-size: 14px;
      float: left;
      background-color: white;
      color: #f64746;
      border-radius: 10px;
      padding-left: 8px;
      padding-right: 8px;
      margin-top: 5px;
      text-align: center;
      line-height: 20px;
    }
  }
  .luckyValue_right {
    width: 50%;
    float: right;
  }
  .luckyValue_right_image_center {
    position: absolute;
    float: right;
    right: 20px;
    z-index: 10;
    height: 140px;
  }
  .luckyValue_right_image_value_not {
    position: absolute;
    right: 20px;
    width: 30%;
    margin-top: 35px;
    background-color: #f64746;
    height: 55px; //55%
    z-index: 20;
  }
  .luckyValue_right_image_value {
    position: absolute;
    float: right;
    right: 20px;
    z-index: 30;
    background-color: transparent;
    height: 140px;
  }
  .luckyValue_right_image_title {
    // background-color: orange;
    color: #ffffff;
    position: absolute;
    float: right;
    right: 20px;
    width: 150px;
    margin-top: 99px;
    font-size: 14px;
    color: #c57613;
    z-index: 40;
    text-align: center;
  }
  .value-animation {
    // position: absolute;
    z-index: 50;
    float: right;
  }
}
</style>
